import type { ClientChatMessage } from '@DigitaleDoerfer/digitale-doerfer-api';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetGroup } from '@/features/api/hooks/grapevine-group/useGetGroup';
import { DeletedRefChatMessage } from '@/features/chats/components/DeletedRefChatMessage';
import { LoadingRefChatMessage } from '@/features/chats/components/LoadingRefChatMessage';
import { RefChatMessage } from '@/features/chats/components/RefChatMessage';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { AppRoute } from '@/navigation/types/navigation';

type Props = {
  message: ClientChatMessage;
};

export const GroupRefChatMessage: FC<Props> = ({ message }) => {
  const { t } = useTranslation(LocalizationNameSpace.CHATS, {
    keyPrefix: 'screens.chat.message'
  });

  const hasRefData =
    message.referencedEntityId != undefined &&
    message.referencedEntityText != undefined &&
    message.referencedEntityDeleted != undefined;

  const deleted = message.referencedEntityDeleted === true;

  const requiresFetch = !hasRefData && !deleted;

  const { data: group, isFetching } = useGetGroup(
    requiresFetch ? message.referencedEntityId : undefined
  );

  const id = message.referencedEntityId ?? '';
  const name = message.referencedEntityText ?? group?.name;

  if (isFetching) {
    return <LoadingRefChatMessage />;
  }

  if (deleted || (requiresFetch && !group)) {
    return <DeletedRefChatMessage />;
  }

  return (
    <RefChatMessage
      screen={AppRoute.GroupDetail}
      params={{
        groupId: id,
        name: name
      }}
      header={t('relatedToGroup', { name })}
    />
  );
};
